import { render } from "./updatepassword.vue?vue&type=template&id=9fc41092"
import script from "./updatepassword.vue?vue&type=script&lang=js"
export * from "./updatepassword.vue?vue&type=script&lang=js"

import "./updatepassword.vue?vue&type=style&index=0&id=9fc41092&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__